import { Button, Modal, Form, Radio, Col, Select, Row } from "antd";
import {
  getClientAPI,
  GetPartnersApi,
  GetPartnerSubClientsApi,
  getProjectsBySubClientAPI,
} from "CommonComponents/Lookup/LookupAPI";
import {
  resetClients,
  resetPartnerSubClients,
  resetPartners,
  resetProjects,
} from "CommonComponents/Lookup/LookupSlice";
import { GetWorkOrdersListByClientId } from "features/Clients/ClientsApi";
import {
  resetClientDetailsById,
  resetEstimateById,
  resetPartnerClientDetailsById,
} from "features/Clients/ClientsSlice";
import { GetWorkOrdersByProjectIdApi } from "features/Invoices/InvoicesAPI";
import { resetWorkorderProjects } from "features/Invoices/InvoicesSlice";
import { use } from "react";
import { useEffect, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

function CreateQuote(props) {
  const intl = useIntl();
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const companyId = localStorage.getItem("CompanyId");
  const clients = useSelector((state) => state.lookup.clientList);
  const partners = useSelector((state) => state.lookup.partnersList);
  const partnerSubClients = useSelector(
    (state) => state.lookup.partnerSubClients
  );
  const projects = useSelector((state) => state.lookup.projects);
  const projectWorkOrders = useSelector(
    (state) => state.invoices.projectWorkOrders
  );
  const partnerDet = useSelector((state) => state?.clients?.partnerClientById);

  const [isPartner, setIsPartner] = useState(false);
  const [partnerSearchTerm, setPartnerSearchTerm] = useState("");
  const [clientSearchTerm, setClientSearchTerm] = useState("");
  const [projectSearchTerm, setProjectSearchTerm] = useState("");

  const [selectedClientId, setSelectedClientId] = useState(null);
  const [selectedPartnerId, setSelectedPartnerId] = useState(null);
  const [selectedProjectId, setSelectedProjectId] = useState(null);
  const [selectedWorkOrderId, setSelectedWorkOrderId] = useState(null);

  //const isPartnerFieldDisabled = Boolean(props?.partnerId); // disable partner select if partnerId passed
  const isClientRadioDisabled = Boolean(props?.partnerId);

  const handleSubmit = async () => {
    try {
      await form.validateFields();
      const values = form.getFieldsValue();

      if (isPartner) {
        if (props.type === "workorder") {
          navigate(
            `/${companyId}/${selectedPartnerId}/partner_client_details/${selectedClientId}/client_details/${selectedProjectId}/projects/addworkorder`
          );
        } else if (props.type === "invoice") {
          navigate(
            `/${companyId}/${selectedPartnerId}/partner_client_details/${selectedClientId}/client_details/${selectedProjectId}/projects/wo_details/${selectedWorkOrderId}/generateinvoice`
          );
        } else {
          // default = estimate
          navigate(
            `/${companyId}/${selectedPartnerId}/partner_client_details/${selectedClientId}/client_details/projects/${selectedProjectId}/addestimate`
          );
        }
      } else {
        if (props.type === "workorder") {
          navigate(
            `/${companyId}/${selectedClientId}/client_details/addworkorder`
          );
        } else if (props.type === "invoice") {
          navigate(
            `/${companyId}/${selectedClientId}/client_details/wo_details/${selectedWorkOrderId}/generateinvoice`
          );
        } else {
          navigate(
            `/${companyId}/${selectedClientId}/client_details/addestimate`
          );
        }
      }
    } catch {
      // validation failed, do nothing
    }
  };

  const modalTitle =
    props.type === "workorder" ? (
      <FormattedMessage id="Common.StartNewWorkOrder" />
    ) : props.type === "invoice" ? (
      <FormattedMessage id="Invoice.GenerateInvoice" />
    ) : (
      <FormattedMessage id="Common.StartNewQuote" />
    );

  const submitButtonText =
    props.type === "workorder" ? (
      <FormattedMessage id="ClientDetails.CreateWo" />
    ) : props.type === "invoice" ? (
      <FormattedMessage id="Invoice.GenerateInvoice" />
    ) : (
      <FormattedMessage id="AddEstimate.AddEstimate" />
    );

  const handleSwitch = () => {
    form.setFieldsValue({ clientId: null, partnerId: null, projectId: null });
    setSelectedClientId(null);
    setSelectedPartnerId(null);
    setSelectedProjectId(null);
    dispatch(resetPartners());
    dispatch(resetClients());
    dispatch(resetPartnerSubClients());
    dispatch(resetProjects());
    dispatch(resetWorkorderProjects());
  };
  // Add selector for client work orders
  const clientWorkOrders = useSelector((state) => state.clients.workOrdersList);

  useEffect(() => {
    if (!isPartner && props.type === "invoice" && selectedClientId) {
      dispatch(
        GetWorkOrdersListByClientId({ page: 1, pageSize: 50 }, selectedClientId)
      );
    }
  }, [selectedClientId, isPartner, props.type]);

  useEffect(() => {
    if (clientSearchTerm !== "") {
      if (selectedPartnerId) {
        dispatch(GetPartnerSubClientsApi(selectedPartnerId, clientSearchTerm));
      } else {
        dispatch(getClientAPI(clientSearchTerm));
      }
    }
    dispatch(resetClients());
    dispatch(resetPartnerSubClients());
  }, [clientSearchTerm]);

  useEffect(() => {
    if (partnerSearchTerm !== "") {
      dispatch(GetPartnersApi(partnerSearchTerm));
    }
    dispatch(resetPartners());
  }, [partnerSearchTerm]);

  useEffect(() => {
    form.setFieldsValue({ clientId: null });
  }, [selectedPartnerId]);

  useEffect(() => {
    if (selectedClientId && isPartner && projectSearchTerm !== "") {
      dispatch(
        getProjectsBySubClientAPI(
          selectedClientId,
          companyId,
          projectSearchTerm
        )
      );
    }
  }, [projectSearchTerm, selectedClientId, isPartner]);

  useEffect(() => {
    if (props.type === "invoice" && selectedProjectId) {
      dispatch(GetWorkOrdersByProjectIdApi(selectedProjectId));
    }
  }, [selectedProjectId]);

  useEffect(() => {
    dispatch(resetClientDetailsById());
    dispatch(resetPartnerClientDetailsById());
    dispatch(resetEstimateById());
  }, []);
  useEffect(() => {
    if (partnerDet?.companyName) {
      setPartnerSearchTerm(partnerDet.companyName);
    }
  }, [partnerDet]);

  useEffect(() => {
    if (partnerDet?.companyName && partners?.length) {
      setIsPartner(true);
      const matchingPartner = partners.find((p) => p.id == props?.partnerId);
      if (matchingPartner) {
        setSelectedPartnerId(matchingPartner.id);
        form.setFieldsValue({ partnerId: matchingPartner.id });
      }
    }
  }, [partnerDet, partners]);

  return (
    <Modal
      title={modalTitle}
      open={props.open}
      width={550}
      onCancel={props.onCancel}
      footer={[
        <Button key="cancel" onClick={props.onCancel}>
          <FormattedMessage id="Common.Cancel" />
        </Button>,
        <Button key="send" type="primary" onClick={handleSubmit}>
          {submitButtonText}
        </Button>,
      ]}
    >
      <Form form={form} name="basic" layout="vertical">
        <Form.Item label={<FormattedMessage id="ProductService.Type" />}>
          <Radio.Group
            onChange={(e) => {
              setIsPartner(e.target.value === "partner");
              handleSwitch();
            }}
            defaultValue={props?.partnerId ? "partner" : "client"}
          >
            <Radio value="client" disabled={isClientRadioDisabled}>
              <FormattedMessage id="AddProject.Client" />
            </Radio>
            <Radio value="partner">
              <FormattedMessage id="Dashboard.Clients.Partner" />
            </Radio>
          </Radio.Group>
        </Form.Item>

        <Row gutter={16}>
          {(isPartner || props?.partnerId) && (
            <Col xs={24}>
              <Form.Item
                label={<FormattedMessage id="Dashboard.Clients.PartnerName" />}
                name="partnerId"
                rules={[
                  {
                    required: true,
                    message: intl.formatMessage({
                      id: "AddEstimate.error.PleaseSelectpartner",
                    }),
                  },
                ]}
              >
                <Select
                  size="large"
                  showSearch
                  allowClear
                  filterOption={false}
                  placeholder={intl.formatMessage({
                    id: "Dashboard.Quotes.Placeholder.SelectPartner",
                  })}
                  onSearch={setPartnerSearchTerm}
                  onChange={(value) => {
                    setSelectedPartnerId(value || null);
                    if (!value) {
                      dispatch(resetPartners());
                      form.setFieldsValue({ clientId: null });
                      setSelectedClientId(null);
                    }
                  }}
                  disabled={isClientRadioDisabled}
                  optionLabelProp="label"
                  notFoundContent={null}
                >
                  {(partners || [])
                    .filter((cl) => cl.isActive)
                    .map((cl) => (
                      <Select.Option
                        key={cl.id}
                        value={cl.id}
                        label={cl.companyName}
                      >
                        {cl.companyName} | {cl.phone}
                      </Select.Option>
                    ))}
                </Select>
              </Form.Item>
            </Col>
          )}
          <Col xs={24}>
            <Form.Item
              label={<FormattedMessage id="AddEstimate.ClientName" />}
              name="clientId"
              rules={[
                {
                  required: true,
                  message: intl.formatMessage({
                    id: "AddEstimate.error.PleaseSelectClient",
                  }),
                },
              ]}
            >
              <Select
                size="large"
                placeholder={intl.formatMessage({
                  id: "AddEstimate.Placeholder.SelectClient",
                })}
                showSearch
                allowClear
                disabled={isPartner && !selectedPartnerId && !props?.partnerId}
                filterOption={false}
                onSearch={setClientSearchTerm}
                onChange={(value) => {
                  setSelectedClientId(value || null);
                  if (!value) {
                    if (isPartner) {
                      dispatch(resetPartnerSubClients());
                    } else {
                      dispatch(resetClients());
                    }
                  }
                }}
                optionLabelProp="label"
                notFoundContent={null}
              >
                {((isPartner ? partnerSubClients : clients) || [])
                  .filter((cl) => cl.isActive)
                  .map((cl) => (
                    <Select.Option
                      key={cl.id}
                      value={cl.id}
                      label={cl.isResidential ? cl.nameEn : cl.companyName}
                    >
                      {cl.isResidential ? cl.nameEn : cl.companyName} |{" "}
                      {cl.phone}
                    </Select.Option>
                  ))}
              </Select>
            </Form.Item>
          </Col>
          {/* Client Work Order */}
          {props.type === "invoice" && !isPartner && selectedClientId && (
            <Col xs={24}>
              <Form.Item
                label={<FormattedMessage id="Invoice.SelectWorkOrder" />}
                name="clientWorkOrderId"
                rules={[
                  {
                    required: true,
                    message: intl.formatMessage({
                      id: "Invoice.error.PleaseSelectWorkOrder",
                    }),
                  },
                ]}
              >
                <Select
                  size="large"
                  placeholder={intl.formatMessage({
                    id: "Invoice.Placeholder.SelectWorkOrder",
                  })}
                  showSearch
                  allowClear
                  filterOption={false}
                  optionLabelProp="label"
                  notFoundContent={null}
                  onChange={(value) => setSelectedWorkOrderId(value || null)}
                >
                  {(clientWorkOrders || []).map((wo) => (
                    <Select.Option
                      key={wo.id}
                      value={wo.id}
                      label={wo.woNumber}
                    >
                      {wo.woNumber}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          )}

          {isPartner && (
            <Col xs={24}>
              <Form.Item
                label={<FormattedMessage id="AddEstimate.ProjectName" />}
                name="projectId"
                rules={[
                  {
                    required: true,
                    message: intl.formatMessage({
                      id: "AddEstimate.error.PleaseSelectProject",
                    }),
                  },
                ]}
              >
                <Select
                  size="large"
                  placeholder={intl.formatMessage({
                    id: "AddEstimate.Placeholder.SelectProject",
                  })}
                  showSearch
                  allowClear
                  filterOption={false}
                  disabled={!selectedClientId}
                  onSearch={setProjectSearchTerm}
                  onChange={(value) => {
                    setSelectedProjectId(value || null);
                    if (!value) {
                      dispatch(resetProjects());
                    }
                  }}
                  optionLabelProp="label"
                  notFoundContent={null}
                >
                  {(projects || []).map((p) => (
                    <Select.Option key={p.id} value={p.id} label={p.name}>
                      {p.name}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          )}
          {/* Invoice Work Order Dropdown */}
          {props.type === "invoice" && selectedProjectId && (
            <Col xs={24}>
              <Form.Item
                label={<FormattedMessage id="Invoice.SelectWorkOrder" />}
                name="workOrderId"
                rules={[
                  {
                    required: true,
                    message: intl.formatMessage({
                      id: "Invoice.error.PleaseSelectWorkOrder",
                    }),
                  },
                ]}
              >
                <Select
                  size="large"
                  placeholder={intl.formatMessage({
                    id: "Invoice.Placeholder.SelectWorkOrder",
                  })}
                  showSearch
                  allowClear
                  filterOption={false}
                  onFocus={() => {
                    dispatch(GetWorkOrdersByProjectIdApi(selectedProjectId));
                  }}
                  onChange={(value) => setSelectedWorkOrderId(value || null)}
                  optionLabelProp="label"
                  notFoundContent={null}
                >
                  {(projectWorkOrders || []).map((wo) => (
                    <Select.Option
                      key={wo.id}
                      value={wo.id}
                      label={wo.woNumber}
                    >
                      {wo.woNumber}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          )}
        </Row>
      </Form>
    </Modal>
  );
}
export default CreateQuote;
